"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spinnerStrokeWidths = exports.spinnerSizes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interfaces = require("./interfaces");

var _spinnerSizes, _spinnerStrokeWidths;

var spinnerSizes = (_spinnerSizes = {}, (0, _defineProperty2.default)(_spinnerSizes, _interfaces.SpinnerSize.ExtraSmall, 16), (0, _defineProperty2.default)(_spinnerSizes, _interfaces.SpinnerSize.Small, 28), (0, _defineProperty2.default)(_spinnerSizes, _interfaces.SpinnerSize.Medium, 70), (0, _defineProperty2.default)(_spinnerSizes, _interfaces.SpinnerSize.Large, 104), _spinnerSizes);
exports.spinnerSizes = spinnerSizes;
var spinnerStrokeWidths = (_spinnerStrokeWidths = {}, (0, _defineProperty2.default)(_spinnerStrokeWidths, _interfaces.SpinnerSize.ExtraSmall, 4), (0, _defineProperty2.default)(_spinnerStrokeWidths, _interfaces.SpinnerSize.Small, 4), (0, _defineProperty2.default)(_spinnerStrokeWidths, _interfaces.SpinnerSize.Medium, 6), (0, _defineProperty2.default)(_spinnerStrokeWidths, _interfaces.SpinnerSize.Large, 8), _spinnerStrokeWidths);
exports.spinnerStrokeWidths = spinnerStrokeWidths;